import { Tab } from 'bootstrap';
import { withPlugins, domEvents } from '@spon/plugins';
import Masonry from 'masonry-layout';

function ArtistProfile({ node, plugins: { addEvents } }) {
	let masonryInstance;
	let container;
	let windowTop = 0;
	let activePane = node.querySelector('.tab-pane.active');

	function masonryInit(id) {
		windowTop = window.scrollY;

		if (masonryInstance) masonryInstance.destroy();

		if (id === '#pane-cv') return;

		container = node.querySelector(id);

		if (!container) return;

		container.style.opacity = 0;

		masonryInstance = new Masonry(container.querySelector('.o-artwork--list'), {
			itemSelector: '.o-artwork',
			percentPosition: 1,
		});

		if (windowTop) window.scroll(0, windowTop);
		container.style.opacity = 1;
	}

	if (node.querySelector('[data-bs-toggle].active')) {
		masonryInit(node.querySelector('[data-bs-toggle].active').dataset.bsTarget);
	}

	function onClick(event) {
		event.preventDefault();

		const {
			href,
			dataset: { bsTarget },
		} = event.target;

		if (href) window.history.replaceState({}, '', href.split('#')[0]);

		masonryInit(bsTarget);

		// update aria
		if (activePane !== bsTarget) {
			activePane.setAttribute('aria-hidden', 'true');
			activePane = node.querySelector(bsTarget);
			activePane.setAttribute('aria-hidden', 'false');
		}
	}

	// Fade during loading. Dont need to remove as dom is updated
	// https://htmx.org/events
	if (typeof htmx !== 'undefined') {
		// eslint-disable-next-line
		htmx.on('htmx:afterSwap', ({ target }) => {
			if (target.id === 'full-portfolio-wrapper') {
				// masonryInstance.layout(); // not working...
				if (node.querySelector('[data-bs-toggle].active').dataset.bsTarget) {
					masonryInit(
						node.querySelector('[data-bs-toggle].active').dataset.bsTarget
					);
				}
			}
		});
	}

	addEvents({
		'shown.bs.tab': onClick,
	});
}

export default withPlugins(domEvents)(ArtistProfile);
